import AuthClient from '@/api/Auth/auth.client';
import store from '@/store';
import Notifier from '@/libs/Notifier';

export default class BancoService {
  constructor() {
    this.client = new AuthClient();
    this.notify = new Notifier();
    this.store = store;
  }

  async refreshToken(refreshToken) {
    try {
      const data = await this.client.refreshToken(refreshToken);
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  async verificaToken() {
    try {
      const data = await this.client.verificaToken();
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  async me() {
    try {
      const data = await this.client.me();
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  async alterarSenha(dados) {
    return this.client.alterarSenha(dados);
  }
}
